




























































import Vue from "vue";
import { mixins } from "vue-class-component";
import { Prop, Component, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import GraphData, {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import jsonURLTotal from "@/shared/UrlsTotal";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";
import TotalGraphMixin from "./totalGraphMixins";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class CaDataPresta extends mixins(TotalGraphMixin) {
  // position:absolute; top:50%; transform: translateY(-50%)
  public dataGetted = false;
  public caValue = { p1: 0, p2: 0, p3: 0, compare: 0 };
  public caLabels = { p1: "", p2: "", p3: "" };

  public config: any;
  // public titre = "";
  @Prop() public myOptions!: MyOptions;
  @Prop() public type!: string;

  @Watch("myOptions", { immediate: true, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  public mounted() {
    this.init();
  }
  /**
   * initialisation des données
   * utilisée aussi pour la maj toutes les 5 minutes(total)
   */
  public init() {
    this.config = {
      site: this.myOptions.site,
      periode: this.myOptions.periode,
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
    };
    if (this.config.site.length === 0) {
      this.config.site = this.sites;
    }
    this.updateWs();
    this.orderConfig(this.myOptions);
    this.getDataPresta();
  }

  /**
   * mise a jour des web service a utiliser
   */
  private updateWs() {
    switch (this.myOptions.periode) {
      case "J":
        this.config.WSP1 = jsonURLTotal.PRESTA_AUJOURDHUI;
        this.config.WSP2 = jsonURLTotal.PRESTA_HIER;
        this.config.WSP3 = jsonURLTotal.PRESTA_DYNAMIQUE_MEME_JOUR_SP;
        this.config.WSCompare = jsonURLTotal.PRESTA_DYNAMIQUE_MEME_JOUR_MP;
        break;
      case "MOIS":
        this.config.WSP1 = jsonURLTotal.PRESTA_MOIS;
        this.config.WSP2 = jsonURLTotal.PRESTA_MOIS_PRECEDENT;
        this.config.WSP3 = jsonURLTotal.PRESTA_MOIS_ANNEE_PRECEDENTE;
        break;
      case "ANNEE":
        this.config.WSP1 = jsonURLTotal.PRESTA_ANNEE;
        this.config.WSP2 = jsonURLTotal.PRESTA_ANNEE_PRECEDENTE;
        break;
    }
  }
  /**
   *
   */
  private getDataPresta() {
    // 0 : presta , 1 : vente
    this.dataGetted = false;
    this.$store
      .dispatch("home/getHomeData", {
        config: this.config,
        WS: this.config.WSP1,
      })
      .then((dataP1: any) => {
        this.caValue.p1 = this.type === "VENTE" ? dataP1[1] : dataP1[0];
        this.$store
          .dispatch("home/getHomeData", {
            config: this.config,
            WS: this.config.WSP2,
          })
          .then((dataP2: any) => {
            // console.log(dataP2);
            this.caValue.p2 = this.type === "VENTE" ? dataP2[1] : dataP2[0];
            this.calculateProgresison();
            this.dataGetted = true;
            this.$store
              .dispatch("home/getHomeData", {
                config: this.config,
                WS: this.config.WSP3,
              })
              .then((dataP3: any) => {
                this.caValue.p3 = this.type === "VENTE" ? dataP3[1] : dataP3[0];
              });
          });
      });
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
